import { render, staticRenderFns } from "./base-title-text.component.vue?vue&type=template&id=0528cbb3"
import script from "./base-title-text.component.ts?vue&type=script&lang=ts&external"
export * from "./base-title-text.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports